import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg-icon"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12.6216 3.10889C12.9647 2.75951 13.4852 2.65207 13.939 2.8374C14.3925 3.02278 14.6899 3.46415 14.6899 3.95459V20.0464C14.6899 20.5368 14.3927 20.9782 13.939 21.1636C13.4851 21.349 12.9648 21.2409 12.6216 20.8911L8.3833 16.5728L2.03467 16.5747C1.71447 16.5747 1.40732 16.4472 1.18115 16.2212C0.955013 15.995 0.827843 15.6883 0.827637 15.3687V8.63232C0.827892 7.96599 1.36827 7.42627 2.03467 7.42627H8.38428L12.6216 3.10889ZM18.2505 8.01123C18.7676 7.59188 19.5276 7.66991 19.9478 8.18701V8.18799C21.9729 10.6837 22.2538 14.0476 20.3433 16.9624C19.9778 17.5196 19.2297 17.6751 18.6724 17.3101C18.1149 16.9446 17.9595 16.1965 18.3247 15.6392C19.6492 13.6184 19.4491 11.4033 18.0737 9.7085C17.6538 9.19085 17.7334 8.4311 18.2505 8.01123Z",
  fill: "black",
  stroke: "#DCDEE3",
  "stroke-width": "0.804599",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }